export enum MerchantOnboardingStatus {
  NO_RECORD = "NO_RECORD",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  NEW = "NEW",
}
